import type { NpiCandidate } from './types';

import { US_STATES } from '@/constants/states';

/** "Jane Q Smith, MD": the name the way the registry lists it, credential last. */
export function candidateName(candidate: NpiCandidate): string {
  const name = [candidate.firstName, candidate.middleName, candidate.lastName]
    .filter(Boolean)
    .join(' ');

  return candidate.credential ? `${name}, ${candidate.credential}` : name;
}

/** "Medical Oncology · Houston, TX", leaving out whatever the registry does not say. */
export function candidateDetail(candidate: NpiCandidate): string {
  const place = [candidate.city, candidate.state].filter(Boolean).join(', ');

  return [candidate.specialty, place].filter(Boolean).join(' · ');
}

/** The name field's starting value, from the server's best guess. */
export function nameFieldDefault(guess: { first: string; last: string } | null): string {
  return guess ? `${guess.first} ${guess.last}` : '';
}

/**
 * The two-letter code for a state written either way, "co", "CO" or
 * "Colorado", or null for anything that is not a US state, DC or territory.
 * A literal reader types the name, and keeping only its first two letters
 * would turn Arizona into Arkansas.
 */
export function normalizeStateCode(value: string): string | null {
  const text = value.trim().replace(/\s+/g, ' ').toLowerCase();

  const match = US_STATES.find(
    (entry) => entry.abbr.toLowerCase() === text || entry.name.toLowerCase() === text
  );

  return match?.abbr ?? null;
}
